/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type UserCreationDtoRoleType = typeof UserCreationDtoRoleType[keyof typeof UserCreationDtoRoleType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserCreationDtoRoleType = {
  CUSTOMER: 'CUSTOMER',
  DISTRIBUTOR: 'DISTRIBUTOR',
  ROOT: 'ROOT',
} as const;
